// extracted by mini-css-extract-plugin
module.exports = {"text":"Interview_text__38TKC","notice":"Interview_notice__1Z_6h"};